//
// Copyright (c) 2023 Emplifi, Inc.
//

import { Command, type ModelWriter } from "ckeditor5";
import {
  ACCORDION_SECTION_BODY,
  ACCORDION_SECTION_HEADER,
  getAccordionElement,
  getAccordionSectionElement,
} from "./util";

export default class RemoveAccordionSectionCommand extends Command {
  execute(): void {
    this.editor.model.change((writer: ModelWriter) => {
      const selection = this.editor.model.document.selection;
      const accordionSectionHeader = getAccordionSectionElement(
        selection,
        ACCORDION_SECTION_HEADER,
      );
      const accordionSectionBody = getAccordionSectionElement(selection, ACCORDION_SECTION_BODY);
      const accordionElement = getAccordionElement(selection);
      if (accordionElement != null && accordionElement.childCount <= 2) {
        writer.remove(accordionElement);
      } else {
        if (accordionSectionHeader) {
          writer.remove(accordionSectionHeader);
        }
        if (accordionSectionBody) {
          writer.remove(accordionSectionBody);
        }
      }
    });
  }

  refresh() {
    const accordionSection = getAccordionSectionElement(this.editor.model.document.selection);
    this.isEnabled = !!accordionSection;
  }
}
